import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { F } from '@fullcalendar/core/internal-common';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';

@Component({
  selector: 'app-mantenimiento-adicional',
  templateUrl: './mantenimiento-adicional.component.html',
  styleUrl: './mantenimiento-adicional.component.css'
})
export class MantenimientoAdicionalComponent {
  constructor(private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private readonly reference: MatDialogRef<MantenimientoAdicionalComponent>
  ) { }
  group: FormGroup
  listaCliente: any[] = []
  listaAgenciaAduana: any[] = []
  listaAlmacen: any[] = []
  listaServicio: any[] = []
  dataTableTarifa: any[] = []
  dataTableServicios: any[] = []
  metadataTableTarifa: newmetadate [] = [
    { field: 'tarifa', title: 'Tarifa', inputType: 'text' },
    { field: 'vigencia_desde', title: 'Vigencia Desde', inputType: 'date' },
    { field: 'vigencia_hasta', title: 'Vigencia Hasta', inputType: 'date' },
    { field: 'descripcion', title: 'Descripción', inputType: 'text' },
    { field: 'concepto', title: 'Concepto', inputType: 'text' },
    { field: 'unidad_base', title: 'Unidad Base', inputType: 'text' },
    { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'importe_venta', title: 'Importe Venta', inputType: 'text' },
  ]
  metadataTableServicios: newmetadate [] = [
    { field: 'descripcion', title: 'Descripcion', inputType: 'text' },
    { field: 'unidad_base', title: 'Unidad Base', inputType: 'text' },
    { field: 'tipo_entidad', title: 'Tipo Entidad', inputType: 'text' },
    { field: 'razon_social', title: 'Razón Social', inputType: 'text' },
    { field: 'venta_unidad', title: 'Venta (Unidad)', inputType: 'decimal' },
    { field: 'moneda', title: 'Moneda', inputType: 'text' },
    { field: 'cantidad', title: 'Cantidad', inputType: 'int' },
    { field: 'venta_total', title: 'Venta (Total)', inputType: 'decimal' },
    { field: 'agrupado_por', title: 'Agrupado Por', inputType: 'int' },
  ]

  ngOnInit(): void {
    console.log(this.data);

  }

  searchTarifa(){

  }

  AddServicio(){

  }

  prefacturar(){

  }

  TransaccionServAdicionales(){

  }

  salir(){
    this.reference.close()
  }
}
